<template>
  <ul class="menu menu--visnet">
    <li>
      <VisnetAttributes :visnet-hub="visnetHub" />
    </li>
    <li>
      <VisnetNetwork :visnet-hub="visnetHub" />
    </li>
  </ul>
</template>

<script>
import VisnetAttributes from '@/components/substations/visnet-hubs/landing-visnet-hub-attributes';
import VisnetNetwork from '@/components/substations/visnet-hubs/network/network';

export default {
  name: 'InfoSection',
  components: {
    VisnetAttributes,
    VisnetNetwork
  },
  props: { visnetHub: Object }
};
</script>
